export const FETCH_SHIPPING_RATES_REQUEST =
  "API/ENTITIES/SHIPPING_RATES/REQUEST";
export const FETCH_SHIPPING_RATES_REQUEST_SUCCESS =
  "API/ENTITIES/SHIPPING_RATES/REQUEST_SUCCESS";
export const FETCH_SHIPPING_RATES_REQUEST_FAILURE =
  "API/ENTITIES/SHIPPING_RATES/REQUEST_FAILURE";
